import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import classNames from 'classnames/bind';

import { Icon, Headline } from '../../elements';
import styles from './Accordion.module.scss';

const cx = classNames.bind(styles);

const Accordion = (props) => {
	const [isOpen, setIsOpen] = React.useState(false);

	return (
		<div className={styles.wrapper}>
			<motion.header className={cx(styles.header, { open: isOpen })}>
				<button onClick={() => setIsOpen(!isOpen)} type='button'>
                    <Headline variant='h3'>{props.title}</Headline>
					<Icon name='chevron_down' size='27' color='#e33333' />
				</button>
			</motion.header>

			<AnimatePresence initial={false}>
				{isOpen && (
					<motion.section
                        className={styles.content}
						key='content'
						initial='collapsed'
						animate='open'
						exit='collapsed'
						variants={{
							open: { opacity: 1, scale: 1, height: 'auto' },
							collapsed: { opacity: 0, scale: 0.9, height: 0 },
						}}
						transition={{ duration: 0.7 }}>
						{props.children}
					</motion.section>
				)}
			</AnimatePresence>
		</div>
	);
};

Accordion.propTypes = {
	title: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Accordion;
